import React, { useState, useEffect, useCallback } from 'react';
import { BACKEND_URL } from '../../../config';
import './AdminMockupsPanel.css';
// import MockupAreaEditor from './MockupAreaEditor'; // Usunięty import

const AdminMockupsPanel = () => {
  const [mockups, setMockups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [newMockupName, setNewMockupName] = useState('');
  const [newMockupFile, setNewMockupFile] = useState(null);
  const [newMockupSmartObjectName, setNewMockupSmartObjectName] = useState('SmartObjectLayer'); // Nowe pole
  const [newMockupTemplateCollectionId, setNewMockupTemplateCollectionId] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  // Stany dla testowania mockupu
  const [showTestModal, setShowTestModal] = useState(false);
  const [testMockupId, setTestMockupId] = useState(null);
  const [testMockupName, setTestMockupName] = useState('');
  const [testSmartObjectName, setTestSmartObjectName] = useState('');
  const [testPdfFile, setTestPdfFile] = useState(null);
  const [isTesting, setIsTesting] = useState(false);
  const [testResultImageUrl, setTestResultImageUrl] = useState(null);
  const [testError, setTestError] = useState(null);

  // Usunięte stany związane z edytorem obszarów
  // const [editingMockup, setEditingMockup] = useState(null);
  // const [originalAreasBeforeEdit, setOriginalAreasBeforeEdit] = useState([]);
  // const [showAreaEditor, setShowAreaEditor] = useState(false);

  const fetchMockups = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${BACKEND_URL}/admin/mockups`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setMockups(data || []);
    } catch (err) {
      console.error("Error fetching mockups:", err);
      setError(err.message || 'Nie udało się pobrać mockupów.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMockups();
  }, [fetchMockups]);

  const handleFileChange = (event) => {
    setNewMockupFile(event.target.files[0]);
  };

  const handleSubmitNewMockup = async (event) => {
    event.preventDefault();
    if (!newMockupName || !newMockupFile) {
      alert('Nazwa mockupu i plik są wymagane.');
      return;
    }

    const formData = new FormData();
    formData.append('name', newMockupName);
    formData.append('mockupImage', newMockupFile);
    formData.append('smartObjectName', newMockupSmartObjectName); // Dodano przesyłanie nazwy warstwy inteligentnej
    if (newMockupTemplateCollectionId) {
      formData.append('templateCollectionId', newMockupTemplateCollectionId);
    }

    setIsUploading(true);
    setError(null);
    try {
      const response = await fetch(`${BACKEND_URL}/admin/mockups`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      setNewMockupName('');
      setNewMockupFile(null);
      setNewMockupSmartObjectName('SmartObjectLayer'); // Resetuj do wartości domyślnej
      setNewMockupTemplateCollectionId('');
      if (document.getElementById('newMockupFile')) {
        document.getElementById('newMockupFile').value = '';
      }
      fetchMockups();
      alert('Mockup dodany pomyślnie!');
    } catch (err) {
      console.error("Error uploading mockup:", err);
      setError(err.message || 'Nie udało się dodać mockupu.');
      alert(`Błąd: ${err.message}`);
    } finally {
      setIsUploading(false);
    }
  };

  const handleDeleteMockup = async (mockupId) => {
    if (!window.confirm('Czy na pewno chcesz usunąć ten mockup? Spowoduje to również usunięcie wszystkich jego obszarów.')) {
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${BACKEND_URL}/admin/mockups/${mockupId}`, {
        method: 'DELETE',
        credentials: 'include',
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      fetchMockups();
      alert('Mockup usunięty pomyślnie.');
    } catch (err) {
      console.error("Error deleting mockup:", err);
      setError(err.message || 'Nie udało się usunąć mockupu.');
      alert(`Błąd: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Usunięte funkcje związane z edytorem obszarów
  // handleOpenAreaEditor, handleCloseAreaEditor, handleSaveAreas

  const handleOpenTestModal = (mockup) => {
    setTestMockupId(mockup.id);
    setTestMockupName(mockup.name);
    setTestSmartObjectName(mockup.smartObjectName || 'SmartObjectLayer');
    setTestPdfFile(null);
    setTestResultImageUrl(null);
    setTestError(null);
    setShowTestModal(true);
  };

  const handleCloseTestModal = () => {
    setShowTestModal(false);
  };

  const handleTestPdfFileChange = (event) => {
    setTestPdfFile(event.target.files[0]);
  };

  const handleExecuteTestMockup = async () => {
    if (!testMockupId || !testPdfFile) {
      alert('Mockup ID i plik PDF są wymagane do testu.');
      return;
    }
    setIsTesting(true);
    setTestError(null);
    setTestResultImageUrl(null);

    const formData = new FormData();
    formData.append('testPdf', testPdfFile);
    formData.append('smartObjectName', testSmartObjectName);
    // projectId nie jest potrzebny dla samego testu wizualizacji,
    // backend może użyć tymczasowego ID lub specjalnego oznaczenia.
    // mockupId jest w URL trasy.

    try {
      // TODO: Zdefiniować i zaimplementować trasę backendu /admin/mockups/:mockupId/test-visualization
      const response = await fetch(`${BACKEND_URL}/admin/mockups/${testMockupId}/test-visualization`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      if (result.success && result.visualizationUrl) {
        setTestResultImageUrl(`${BACKEND_URL}${result.visualizationUrl}`); // Zakładając, że URL jest relatywny
        alert('Test mockupu zakończony pomyślnie!');
      } else {
        throw new Error(result.message || 'Nie udało się wygenerować wizualizacji testowej.');
      }
    } catch (err) {
      console.error("Error testing mockup:", err);
      setTestError(err.message || 'Nie udało się przetestować mockupu.');
      alert(`Błąd testowania: ${err.message}`);
    } finally {
      setIsTesting(false);
    }
  };


  return (
    <div className="admin-mockups-panel">
      <h2>Zarządzanie Mockupami</h2>

      {error && <p className="error-message">Błąd: {error}</p>}

      {/* Usunięty warunkowy rendering MockupAreaEditor */}

      {showTestModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Testuj Mockup: {testMockupName}</h3>
            <div>
              <label htmlFor="testSmartObjectName">Nazwa Warstwy Inteligentnej:</label>
              <input
                type="text"
                id="testSmartObjectName"
                value={testSmartObjectName}
                onChange={(e) => setTestSmartObjectName(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="testPdfFile">Plik PDF Projektu do Testu:</label>
              <input
                type="file"
                id="testPdfFile"
                accept=".pdf"
                onChange={handleTestPdfFileChange}
              />
            </div>
            {testResultImageUrl && (
              <div className="test-result">
                <h4>Wynik Testu:</h4>
                <img src={testResultImageUrl} alt="Wynik testu mockupu" style={{ maxWidth: '100%', maxHeight: '400px' }} />
              </div>
            )}
            {testError && <p className="error-message">Błąd testu: {testError}</p>}
            <div className="modal-actions">
              <button onClick={handleExecuteTestMockup} disabled={isTesting || !testPdfFile}>
                {isTesting ? 'Testowanie...' : 'Uruchom Test'}
              </button>
              <button onClick={handleCloseTestModal} disabled={isTesting}>Anuluj</button>
            </div>
          </div>
        </div>
      )}

      <>
        <div className="add-mockup-form">
          <h3>Dodaj Nowy Mockup (PSD)</h3>
          <form onSubmit={handleSubmitNewMockup}>
            <div>
              <label htmlFor="newMockupName">Nazwa Mockupu:</label>
              <input
                type="text"
                id="newMockupName"
                value={newMockupName}
                onChange={(e) => setNewMockupName(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="newMockupFile">Plik Mockupu (PSD):</label>
              <input
                type="file"
                id="newMockupFile"
                accept=".psd" // Akceptuj tylko pliki .psd
                onChange={handleFileChange}
                required
              />
            </div>
            <div>
              <label htmlFor="newMockupSmartObjectName">Nazwa Warstwy Inteligentnej (Smart Object):</label>
              <input
                type="text"
                id="newMockupSmartObjectName"
                value={newMockupSmartObjectName}
                onChange={(e) => setNewMockupSmartObjectName(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="newMockupTemplateCollectionId">ID Kolekcji Szablonów (opcjonalnie):</label>
              <input
                type="number"
                id="newMockupTemplateCollectionId"
                value={newMockupTemplateCollectionId}
                onChange={(e) => setNewMockupTemplateCollectionId(e.target.value)}
                placeholder="np. 50"
              />
            </div>
            <button type="submit" disabled={isUploading}>
              {isUploading ? 'Przesyłanie...' : 'Dodaj Mockup'}
            </button>
          </form>
        </div>

        <div className="mockups-list">
          <h3>Lista Mockupów</h3>
          {isLoading && <p>Ładowanie mockupów...</p>}
          {!isLoading && mockups.length === 0 && <p>Brak mockupów do wyświetlenia.</p>}
          {!isLoading && mockups.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Podgląd (PSD)</th>
                  <th>Nazwa</th>
                  <th>Nazwa Pliku</th>
                  <th>Warstwa Inteligentna</th>
                  <th>Powiązana Kolekcja (ID)</th>
                  <th>Akcje</th>
                </tr>
              </thead>
              <tbody>
                {mockups.map((mockup) => (
                  <tr key={mockup.id}>
                    <td>{mockup.id}</td>
                    <td>
                      {/* Podgląd dla PSD może być trudny do wyświetlenia bezpośrednio, można pokazać ikonę lub nazwę pliku */}
                      {mockup.filename || 'Brak pliku'}
                    </td>
                    <td>{mockup.name}</td>
                    <td>{mockup.originalName || mockup.filename}</td>
                    <td>{mockup.smartObjectName || 'SmartObjectLayer'}</td> {/* Wyświetlenie nazwy warstwy */}
                    <td>{mockup.templateCollectionId || 'Brak'}</td>
                    <td>
                      <button onClick={() => alert(`Edycja mockupu ID: ${mockup.id} - do zaimplementowania`)}>Edytuj</button>
                      <button onClick={() => handleDeleteMockup(mockup.id)} className="delete-button">Usuń</button>
                      {/* Przycisk "Obszary" usunięty, poniżej będzie "Testuj" */}
                      {/* <button onClick={() => handleOpenAreaEditor(mockup)}>Obszary</button> */}
                       <button onClick={() => handleOpenTestModal(mockup)}>Testuj</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </>
    </div>
  );
};

export default AdminMockupsPanel;
